// NOTE: AD_IDS_ITEM, PROVIDER_AD_LIST and USER_COHORT_ITEM are also imported
// directly from here by onboarding/KYC and dataSource modules — keep them in
// this file (don't move them into a SignUp-only file) unless those call
// sites are updated too.

export const SIGN_UP_QUERY_PARAMS = {
  ROLE: 'role',
  INVITATION_CODE: 'invitation_code',
  REFERRAL_CODE: 'referral_code',
  ENABLE_BANK_TESTING: 'enable_bank_testing',
};

export const PROVIDER_AD_LIST = [
  'gclid',
  'fbclid',
  'msclkid',
  'twclid',
  'Sccid',
  'ttclid',
  'pclid',
  'qclid',
  'yclid',
  'rdclid',
  'li_fat_id',
  'adobe_mc',
  'gbraid',
  'wbraid',
  'oppref', // ChatGPT
];

export const AD_IDS_ITEM = 'AD_IDS';
export const USER_COHORT_ITEM = 'user_cohort';

// The 3 steps of the sign-up wizard — step 1 collects name/referral code,
// step 2 phone/email, step 3 password. Also referenced by SignUpPage.tsx.
export const SIGN_UP_STEP = {
  PERSONAL_INFO: 1,
  CONTACT_INFO: 2,
  PASSWORD: 3,
} as const;

export type SignUpStepValue = (typeof SIGN_UP_STEP)[keyof typeof SIGN_UP_STEP];
